import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useTranslationStore = defineStore("translation", () => {
  const httpStore = useHttpStore();

  const upsertTranslationDictionaryItem = (englishKey) => {
    var params = {
      englishKey,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "translation/upsertTranslationDictionaryItem", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateTranslationDictionary = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "translation/UpdateTranslationDictionary", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getTranslationDictionary = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "translation/getTranslationDictionary", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

    const getTranslationRequestSummary = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "translation/getTranslationRequestSummary", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    upsertTranslationDictionaryItem,
    updateTranslationDictionary,
    getTranslationDictionary,
    getTranslationRequestSummary
  };
});
